export const SENDING_REQUEST = 'CLASSIFIERLIST_SENDING_REQUEST';
export const GETALL_SUCCESS = 'CLASSIFIERLIST_GETALL_SUCCESS';
export const GETALL_FAILURE = 'CLASSIFIERLIST_GETALL_FAILURE';